import { JobActivitiesProvider } from '../../providers/JobActivitiesProvider';
import { AsideLayout } from '../../layout/AsideLayout';
import { JobActivitiesList } from './JobActivitiesList';
import { useRecoilValue } from 'recoil';
import { selectedJobActivityIdState } from '../../../storage/jobTypesStates';
import { JobActivityDetail } from './JobActivityDetail';

export function JobActivities() {
  const selectedActivityId = useRecoilValue(selectedJobActivityIdState);

  return (
    <>
      <JobActivitiesProvider />
      <AsideLayout
        canHide={selectedActivityId !== undefined}
        aside={<JobActivitiesList />}
      >
        {selectedActivityId !== undefined && <JobActivityDetail />}
      </AsideLayout>
    </>
  );
}
